var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1000_3297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.9165 8.16406V1.16406",
    stroke: "#1F2937",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.24979 10.5674L5.83312 8.16406H2.43229C2.25117 8.16406 2.07254 8.12189 1.91054 8.04089C1.74854 7.9599 1.60763 7.84229 1.49896 7.6974C1.39029 7.5525 1.31684 7.38429 1.28444 7.2061C1.25204 7.0279 1.26158 6.8446 1.31229 6.67073L2.67146 2.00406C2.74214 1.76173 2.88951 1.54886 3.09146 1.3974C3.2934 1.24594 3.53903 1.16406 3.79146 1.16406H11.6665C11.9759 1.16406 12.2726 1.28698 12.4914 1.50577C12.7102 1.72456 12.8331 2.02131 12.8331 2.33073V6.9974C12.8331 7.30681 12.7102 7.60356 12.4914 7.82235C12.2726 8.04115 11.9759 8.16406 11.6665 8.16406H10.0565C9.83941 8.16418 9.6267 8.22484 9.44223 8.33923C9.25777 8.45361 9.10888 8.61719 9.01229 8.81156L6.99979 12.8307C6.7247 12.8273 6.45394 12.7618 6.20774 12.639C5.96153 12.5163 5.74625 12.3395 5.57797 12.1219C5.40969 11.9042 5.29277 11.6514 5.23594 11.3822C5.17912 11.113 5.18385 10.8345 5.24979 10.5674Z",
    stroke: "#1F2937",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1000_3297"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDown);
export default __webpack_public_path__ + "static/media/thumbs-down.eb498db0c7a6ac372126991af2f9b1d0.svg";
export { ForwardRef as ReactComponent };